module.exports = __webpack_public_path__ + "img/skill.8a49fb84.png";